export default __webpack_public_path__ + "static/media/info-icon.a42a20ab.svg";